export default function sendEvent(eventName, additionalData = {}) {
  sessionStorage.setItem("__SE_WAS", true);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...additionalData
  });
}
